import React, { useState } from 'react';
import { Button, Flex, Modal } from 'antd';
import { ClearSvg } from '../svgs';
import TimelineActionButtons from './TimelineActionButtons';
import { NODES_TYPES } from '../types';

interface HeaderControlsProps {
  saveTimeline: () => void;
  deleteTimeline: () => void;
  isTimelineMode: boolean;
  setNodes?: (callback: (nds: any[]) => any[]) => void;
  selectedNode: any | null;
  addNodeAtCenter: (type: NODES_TYPES) => void;
  hasChanges: boolean;
  loading: boolean;
}

export default function HeaderControls({
  saveTimeline,
  deleteTimeline,
  isTimelineMode,
  selectedNode,
  addNodeAtCenter,
  hasChanges,
  loading,
}: HeaderControlsProps) {
  const [isClearModalVisible, setIsClearModalVisible] =
    useState<boolean>(false);

  const handleClearTimeline = () => {
    setIsClearModalVisible(true);
  };

  const handleConfirmClear = () => {
    deleteTimeline();
    setIsClearModalVisible(false);
  };

  const handleCancelClear = () => {
    setIsClearModalVisible(false);
  };

  return (
    <>
      <Flex
        align='center'
        justify='space-between'
        gap={16}
        style={{ width: '100%' }}
      >
        {isTimelineMode && (
          <TimelineActionButtons
            addNodeAtCenter={addNodeAtCenter}
            selectedNode={selectedNode}
          />
        )}
        <Flex gap={16} align='center'>
          <Button
            type='primary'
            onClick={saveTimeline}
            disabled={!hasChanges || loading}
            loading={loading}
          >
            <img
              src={'/save-icon.svg'}
              alt='icon'
              width={17}
              height={17}
              style={{ marginTop: -2, marginRight: 5 }}
            />
            Save Timeline
          </Button>
          <Button
            color='danger'
            onClick={handleClearTimeline}
            disabled={loading}
          >
            {ClearSvg}
            Clear Timeline
          </Button>
        </Flex>
      </Flex>

      <Modal
        title='Clear Timeline'
        open={isClearModalVisible}
        onOk={handleConfirmClear}
        onCancel={handleCancelClear}
        okText='Clear'
        cancelText='Cancel'
        okButtonProps={{ danger: true }}
      >
        <p>
          Are you sure you want to clear the timeline? This action cannot be
          undone.
        </p>
      </Modal>
    </>
  );
}
